/**
 * @file routes/loader.ts
 * @description loader to resolve the routes based on the app edition
 *
 * @author ogarcia (ozkary)
 *
 */
import ppmRouter from './index';
import vscRouter from '../vsc/routes';
import renewRoutes from '../renew/routes';
import { isRenewal, isVsc } from '../services/settings';

// solves the selected edition routing component
const EditionRouter = isRenewal ? renewRoutes : isVsc ? vscRouter : ppmRouter;
export default EditionRouter;
